<div class="game-replay__container" *transloco="let t; prefix: 'pages.game-component'">
  <app-nav-button icon="close" (clickEvent)="onCloseClicked()" class="game-replay__back-button" />
  @if (gameInterfaceState() === GameInterfaceState.ReplayReady) {
    @let primary = reward()?.primary;
    @let secondary = reward()?.secondary;
    <div class="game-replay__content">
      <div class="game-replay__prize">
        <div [ngStyle]="prizeStyles | theme" class="game-replay__prize-content">
          <span>{{ t("prize") }} </span>
          @if (primary?.iconPosition === "start" && primary?.icon; as icon) {
            <app-currency-icon [icon]="icon" sizeCss="--icon-medium" />
          }
          {{ primary?.text }}
          @if (primary?.iconPosition === "end" && primary?.icon; as icon) {
            <app-currency-icon [icon]="icon" sizeCss="--icon-medium" />
          }
          @if (hasSecondaryCurrency) {
            <span class="secondary-span">
              {{ "(" }}
              <span class="secondary-icon-span">
                @if (secondary?.iconPosition === "start" && secondary?.icon; as icon) {
                  <app-currency-icon [icon]="icon" sizeCss="--icon-medium" />
                }
                {{ secondary?.text }}
                @if (secondary?.iconPosition === "end" && secondary?.icon; as icon) {
                  <app-currency-icon [icon]="icon" sizeCss="--icon-medium" />
                }
              </span>
              {{ ")" }}
            </span>
          }
        </div>
      </div>
      <div class="game-replay__room">
        <div [ngStyle]="roomStyles | theme">
          <span>{{ roomId() }}</span>
        </div>
      </div>
    </div>
  }
</div>
